<template>
  <div>
    <!-- <div class="hidden-detail" @click="close">
      <i class="el-icon-close"></i>
    </div>-->
    <el-button
      @click="close"
      type="text"
      class="newBackBtn"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="clearfix"></div>
    <el-form
      :loading="loading"
      status-icon
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-form-item
        v-for="(item, index) in data.detailLimit"
        :key="index"
        :label="item.label ? item.label + ':' : ''"
        :prop="item.prop || ''"
      >
        <div v-if="item.img">
          <div
            class="img-group"
            v-if="item.str2Arr && data.formData[item.prop]"
          >
            <template v-if="typeof data.formData[item.prop] === 'string'">
              <template v-if="data.formData[item.prop].includes(',')">
                <div
                  v-for="(v, k) in data.formData[item.prop].split(',')"
                  :key="k"
                  class="img"
                >
                  <template v-if="v">
                    <div class="index">{{ k + 1 }}</div>
                    <img
                      @click="showPic(v)"
                      crossorigin="anonymous"
                      loading="lazy"
                      style="height: 200px; width: auto; margin-left: 10px;"
                      :src="v"
                      alt=""
                    />
                  </template>
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(v, k) in data.formData[item.prop].split(';')"
                  :key="k"
                  class="img"
                >
                  <div class="index">{{ k + 1 }}</div>
                  <img
                    @click="showPic(v)"
                    crossorigin="anonymous"
                    loading="lazy"
                    style="height: 200px; width: auto; margin-left: 10px;"
                    :src="v"
                    alt=""
                  />
                </div>
              </template>
            </template>
            <template v-else>
              <div
                v-for="(v, k) in (data.formData[item.prop] || []).filter(
                  r => r && r != 'null'
                )"
                :key="k"
                class="img"
              >
                <div class="index">{{ k + 1 }}</div>
                <img
                  @click="showPic(v)"
                  style="height: 200px; width: auto; margin-left: 10px;"
                  :src="v"
                  alt=""
                />
              </div>
            </template>
          </div>
          <img
            @click="showPic(data.formData[item.prop])"
            v-else
            crossorigin="anonymous"
            loading="lazy"
            style="height: 200px; width: auto;"
            :src="data.formData[item.prop]"
            alt=""
          />
        </div>
        <div v-else-if="item.file">
          <div v-for="(t, i) in handleFiles(data.formData[item.prop])" :key="i">
            <a :href="t.src" style="color: #1890ff;">{{ t.name }}</a>
          </div>
        </div>
        <div v-else-if="item.formatter">
          {{ item.formatter(data.formData) }}
        </div>
        <div v-else>
          {{ data.formData[item.prop]
          }}{{ item.prop === 'visitMinute' ? '分钟' : '' }}
        </div>
      </el-form-item>
    </el-form>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      @close="closeDialog"
      width="80%"
      center
    >
      <div class="show-img-in-detail">
        <img crossorigin="anonymous" loading="lazy" :src="targetSrc" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import {objectFormat} from '@/tools/objectFormat.js'
import { btLoading } from '@/Mixin/btLoading';

export default {
  name: 'formDetail',
  mixins: [btLoading],
  components: [],
  props: {
    data: {
      type: Object,
      default: {
        formData: {
          customerName: ''
        },
        detailLimit: [
          {
            label: '发单企业',
            prop: 'customerName'
          },
          {
            label: '项目名称',
            prop: 'customerName'
          },
          {
            label: '药店',
            prop: 'customerName'
          },
          {
            label: '巡店时间',
            prop: 'customerName'
          },
          {
            label: '药店定位',
            prop: 'customerName'
          },
          {
            label: '产品名称',
            prop: 'customerName'
          },
          {
            label: '全国指导价',
            prop: 'customerName'
          },
          {
            label: '产品售价',
            prop: 'customerName'
          },
          {
            label: '陈列要求',
            prop: 'customerName'
          },
          {
            label: '陈列状态',
            prop: 'customerName'
          },
          {
            label: '陈列照片',
            prop: 'customerName',
            str2Arr: true,
            img: true
          }
        ]
      }
    }
  },
  data() {
    return {
      loading: true, // 表单 loading
      formLabelWidth: '120px',
      centerDialogVisible: false,
      targetSrc: ''
    };
  },
  watch: {},
  methods: {
    close() {
      this.$router.back();
      // this.$parent.hideDetail()
      this.$parent.hideDetail();
    },

    handleFiles(str) {
      let list = [];
      if (!str || !this.data.formData.bingliFileName) {
        return list;
      }
      let nameList = this.data.formData.bingliFileName.split(',');
      let strList = str.split(',');
      for (let i = 0; i < strList.length; i++) {
        list.push({ src: strList[i], name: nameList[i] });
      }
      return list;
    },
    //---------------------------------------//
    closeDialog() {
      this.targetSrc = '';
    },
    showPic(src) {
      this.targetSrc = src;
      this.centerDialogVisible = true;
    },
    eventClose() {
      // 关闭窗口
      this.$emit('update:showUserAddEdit', false); // 逆向修改
    }
    //提交
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
};
</script>

<style scoped lang="scss">
.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
  height: 2em;
}

.img-group .img {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.show-img-in-detail {
  & > img {
    width: 100% !important;
    height: auto !important;
  }
  width: 100%;
}
.img-group .img .index {
  margin-right: 15px;
}
</style>
